import axios from 'axios';
import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';

import { constants, logger, url } from 'app/utils';

import { OidcUserManager } from './oidcUserManager';

const redirect_uri = `${url.getAppBaseUrl()}${constants.Routes.AccountCallback}`;
const post_logout_redirect_uri = `${url.getAppBaseUrl()}${constants.Routes.Home}`;

const userManagerSettings: UserManagerSettings = (() => {
  if (!window.CONFIG.idamURL || !window.CONFIG.idamClientId) {
    throw new Error('REACT_APP_AUTHORITY_URL or REACT_APP_AUTHORITY_CLIENT_ID are unset');
  }

  return {
    authority: window.CONFIG.idamURL,
    client_id: window.CONFIG.idamClientId,
    scope: 'customer:rw openid phone email profile',
    redirect_uri,
    post_logout_redirect_uri,
    response_type: 'code',
    automaticSilentRenew: true,
    extraQueryParams: { createFlag: 'ca' },
    userStore: new WebStorageStateStore({ prefix: 'sv-token', store: window.sessionStorage })
  };
})();

const userManager = new OidcUserManager(userManagerSettings);

/**
 * Header proprs relating to sign in and sign outs
 */
export const signinHeaderProps = {
  showLogin: true,
  client_id: window.CONFIG.idamClientId,
  loginUrl: window.CONFIG.idamURL,
  redirect_uri,
  post_logout_redirect_uri
};

/**
 * Initiates the authentication flow.
 */
export const startUserSignin = async () => {
  await userManager.signinRedirect();
};

/**
 * Returns the currently authenticated user's data.
 */
export const getUserData = async () => {
  return await userManager.getUser();
};

/**
 * Exchanges the auth code for access, refresh and ID tokens.
 */
export const signinUser = async () => {
  await userManager.signinRedirectCallback();
};

/**
 * Refresh the auth code for access.
 */
export const refreshToken = async () => {
  await userManager.refreshToken();
};

export const invalidateIDAMCookie = async () => {
  const idToken = (await getUserData())?.id_token;

  if (!idToken) {
    return;
  }

  // Invalidate IDAM cookie
  try {
    const endSessionEndpoint = `${userManagerSettings.authority}/connect/endSession`;
    await axios.get(endSessionEndpoint, {
      params: { id_token_hint: idToken }
    });
  } catch (error: any) {
    // Log exception but allow function to continue
    logger.warn('Error when invalidating IDAM cookie', error);
  }
};

export const signOutRedirect = async () => {
  await userManager.signoutRedirect();
};

export const signOutRedirectCallback = async () => {
  await userManager.signoutRedirectCallback();
};
